import classNames from "classnames";

import { CountryCellContent } from "app/components/React/Table/cells/CountryCellContent";
import { countryTextByIdFilter } from "app/filters/ngFilters";

interface CountryCellProps {
    className?: string;
    value: any;
}

export const CountryCell = ({ className, value }: CountryCellProps) => {
    const text = countryTextByIdFilter()(value);

    return (
        <div className={classNames("swTable-countryCell", className)}>
            <CountryCellContent
                countryCode={value}
                text={text}
            />
        </div>
    );
};
CountryCell.displayName = "CountryCell";
